"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineLessOrGreaterThan = void 0;
function defineLessOrGreaterThan(lowValueLimit, highValueLimit) {
    if (!lowValueLimit && !highValueLimit) {
        return "";
    }
    else if (!lowValueLimit || (highValueLimit && lowValueLimit < highValueLimit)) {
        return String.fromCharCode(0x2264);
    }
    else {
        return String.fromCharCode(0x2265);
    }
}
exports.defineLessOrGreaterThan = defineLessOrGreaterThan;
